<template>
  <div>

    <div class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary" id="order_filter_direction">Направление</span>
      <radio name="direction" label="Все" value="all" v-model="directionModel" class="mt4 mt3-l mh2" id="order_filter_direction_all" />
      <radio name="direction" label="Исходящие" value="out" v-model="directionModel" class="mt4 mt3-l mh2" id="order_filter_direction_outbox" />
      <radio name="direction" label="Входящие" value="in" v-model="directionModel" class="mt4 mt3-l mh2" id="order_filter_direction_inbox" />
    </div>

    <div class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary">Статус</span>
      <checkbox v-for="(stat, index) in statuses" :key="index" class="mt4 mt3-l mh2"
        :label="getStatusLabel(stat)"
        :value="stat.code"
        :checked="statusChecked(stat.code)"
        @change="toggleStatus"/>
    </div>

    <div v-if="contract" class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary">Договор</span>
      <live-field :field="contractModel" :save="updateContractModel" #default="{ field, update, saving }" class="mt4 mt3-l ph2" id="order_filter_order_id">
        <integer-field :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
      </live-field>
    </div>

    <div v-if="order" class="flex flex-column mv2 bg-light pv3 ph2">
      <span class="mh2 text-secondary">Заказ</span>
      <live-field :field="orderModel" :save="updateOrderModel" #default="{ field, update, saving }" class="mt4 mt3-l ph2" id="order_filter_order_id">
        <integer-field :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
      </live-field>
    </div>

    <div class="flex flex-column mv2 bg-light pv3 ph2" id="order_filter_sort">
      <span class="mh2 text-secondary">Сортировка</span>
      <radio name="order_sort" label="Сначала новые" value="desc" v-model="sortModel" class="mt4 mt3-l mh2" id="order_filter_sort_desc"/>
      <radio name="order_sort" label="Сначала старые" value="asc" v-model="sortModel" class="mt4 mt3-l mh2" id="order_filter_sort_asc"/>
    </div>

  </div>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'
import Checkbox from '@/components/ui/Checkbox.vue'
import Radio from '@/components/ui/Radio.vue'
import LiveField from '@/components/common/form/LiveField.vue'
import IntegerField from '@/components/common/form/scalar/IntegerField.vue'
import InputOnly from '@/components/common/form/templates/InputOnly.vue'
import { addUniqueToArray, removeFromArray } from '@/utils/filters.js'

export default {
  components: {
    SearchSelect,
    Checkbox,
    Radio,
    LiveField,
    IntegerField,
    InputOnly
  },
  props: {
    checked: { type: Array, required: true },
    sort: { type: String, required: true },
    direction: { type: String, required: true },
    placeholders: { type: Object, required: true },
    stats: { type: Object, required: true },
    contract: { type: Object },
    order: { type: Object }
  },
  computed: {
    company: {
      get () { return null },
      set (value) { }
    },
    sortModel: {
      get () { return this.sort },
      set (value) { this.$emit('updated', { sort: value }) }
    },
    directionModel: {
      get () {
        console.log('filter direction props', this.direction)
        return this.direction
      },
      set (value) { this.$emit('updated', { direction: value }) }
    },
    contractModel () {
      return {
        value: this.contract.id, spec: { editable: true, placeholder: 'ID договора' }
      }
    },
    orderModel () {
      return {
        value: this.order.id, spec: { editable: true, placeholder: 'ID заказа' }
      }
    },
    statuses () {
      return this.$store.getters['order/statuses']
    },
    companies () {
      return this.$store.getters['order/companies']
    }
  },
  methods: {
    statusChecked (code) {
      return this.checked.includes(code)
    },
    toggleStatus (status) {
      var checked = this.$lo.clone(this.checked)
      this.$emit('updated', {
        statuses: status.checked ? addUniqueToArray(checked, status.value) : removeFromArray(checked, status.value)
      })
    },
    getStatusLabel (status) {
      const stats = this.stats
      const statusStats = (stats || {})[status.code]
      return statusStats
        ? `${status.title}(${statusStats})`
        : status.title
    },
    updateContractModel (contractField, value) {
      this.$emit('updated', { contract: value })
      return Promise.resolve({})
    },
    updateOrderModel (orderField, value) {
      this.$emit('updated', { order: value })
      return Promise.resolve({})
    }
  },
  data () {
    return {
      fieldTemplate: InputOnly
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
